export default {
  title: 'Offers',
  page_title: 'All offer templates | Thanx',
  create_reward: 'Create a new offer template',
  title_info_header: 'managing offer templates',
  title_info:
    'This is where you define reusable templates for the offers you want to give customers. You define the discount, display text, and more, but you’re not giving away an offer just yet.\nTo grant customers an offer you must add an active offer template to a campaign. Or you can grant an offer when responding to customer feedback.',
  empty_list: 'You currently have no offers.',
  tabs: {
    create_reward: 'Create a new offer template',
    published: {
      title: 'active',
      subtitle: 'Active templates',
      description:
        'Reusable offer templates you can add to campaigns, loyalty programs, and customer feedback in order to grant offers to customers.',
      no_template_title: 'You don’t have active offer templates',
      no_template_description:
        'These are reusable offer templates that you can add to campaigns, loyalty programs, and customer feedback in order to grant offers to customers.',
    },
    unpublished: {
      title: 'drafts',
      subtitle: 'Draft templates',
      description:
        'Reusable offer templates you started creating but did not activate.',
      no_template_title: 'You don’t have any drafts',
      no_template_description:
        'Offer templates you started creating but did not activate.',
    },
    archived: {
      title: 'archived',
      subtitle: 'Archived templates',
      description:
        'Not available to use in campaigns, loyalty programs, and customer feedback.',
      no_template_title: 'You don’t have archived offer templates',
      no_template_description:
        'Archived offer templates are hidden from campaigns, loyalty programs, and customer feedback. You can’t add archived templates to campaigns, loyalty programs, or customer feedback.',
    },
    column_titles: {
      name: 'Offer name',
      date_created: 'Date created',
      status: 'Status',
    },
  },
  redeem_item: {
    edit: 'Edit',
    view: 'View',
    multi_use: 'MULTI-USE',
  },
  welcome: {
    title: 'Welcome!',
    description_1:
      'An offer template is a pre-built definition for the type of offer you want to give to customers, for example $5 off an order.',
    description_2:
      'The template is not the actual offer. You can add the offer template to campaigns, loyalty programs, and customer feedback responses later to grant an actual offer to a customer, for example actually give a customer $5.',
  },
}
